import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";

import "./App.css";

const data = {
  show: "thoughts",
  thoughts: [
    {
      thought:
        "I am not what I think I am, and I am not what you think I am. I am what I think you think I am.",
      citation: "Charles Horton Cooley",
    },
    {
      thought:
        "It is better to live your own destiny imperfectly than to live an imitation of somebody elses life with perfection.",
      citation: "Bhagavad Gita 3.35",
    },
    {
      thought:
        "Your identity is a mirror covered with dust. When you first look in the mirror, the truth of who you are and what you value is obscured. Clearing it may not be pleasant, but only when the dust is gone can you see your true reflection.",
      citation: "",
    },
    {
      thought:
        "The only thing that stays with you from the moment you're born until the moment you die is your breath. All your friends, your family, the country you live in, all of that can change, but your breath stays with you.",
      citation: "",
    },
    {
      thought:
        "When you get stressed\u2014what changes? Your breath. When you get angry\u2014what changes? Your breath. We experience every emotion with the change of the breath. When you learn to navigate and manage your breath, you can navigate any situation in life.",
      citation: "",
    },
    {
      thought: "If you want a new idea, read an old book.",
      citation: "Ivan Pavlov (among others)",
    },
    {
      thought:
        "What good things have you done so far today? What positive qualities does this show in you? \n\n We all have a critical voice in our head and can sometimes forget to acknowledged our good points. Overlooking our positives will feed low self esteem.",
      citation: "",
    },
    {
      thought:
        "When you try to live your most authentic life, some of your relationships will be put in jeopardy. Losing them is a risk worth bearing; finding a way to keep them in your life is a challenge worth taking on.",
      citation: "Jay Shetty",
    },
    {
      thought:
        "When we tune out the opinions, expectations, and obligations of the world around us, we begin to hear ourselves.",
      citation: "Jay Shetty",
    },
    {
      thought:
        "Knowing what you value in life makes it easier to surround yourself with the right people, make tough career choices, use your time more wisely, and focus your attention where it matters. Without knowing we are swept away by distractions.",
      citation: "Jay Shetty",
    },
    {
      thought: "I get things wrong, I get things right. I am a learner.",
      citation: "Steven Tew",
    },
    {
      thought:
        "## Relax. \n Deep breathing, meditation, progressive muscle relaxation, yoga, tai chi, spending time in nature, or with friends, massage, soothing sounds, or just activities that I enjoy. \n\n The more I practice, the deeper my relaxation becomes.",
      citation: "",
    },
    {
      thought:
        "Challenge your fears, anxieties and negative thoughts with Behaviour Experiments.",
      citation: "",
    },
    {
      thought:
        "## Thinking errors: \n Mind reading; fortune telling; jumping to conclusions; black and white thinking; should and musts; catastrophising; judgements; self-criticism. \n\n Spot them and correct them.",
      citation: "",
    },
    {
      thought:
        "'What was going through my mind just then?'\n When you notice a change in how you're feeling, catch the thought and write it down quickly so it's not dismissed. Then use a Thought Record to challenge it.",
      citation: "",
    },
    {
      thought:
        "Automatic thoughts are often based on assumptions not facts. They're very believable but they can be inaccurate too. You can identify the inaccurate ones with a Thought Record.",
      citation: "",
    },
    {
      thought:
        "## Got a problem? Don't stress. \n Write it down and see if you can come up with 3 solution candidates instead. \n\n What are the pros and cons of each? Which is your least and most favourite?",
      citation: "",
    },
    {
      thought:
        "## Fact! \n Getting active improves low mood. \n\n More routine activities, more pleasurable activities, more necessary activities. Plan them in. Get a good balance of Achievements, Connections, Enjoyments.",
      citation: "",
    },
  ],
  tech: [
    {
      thought:
        "Your head tag is the single biggest render-blocking part of your pages; it blocks rendering of the entire page. ",
      citation: "Harry Roberts",
      tags: ["performance", "HTML"],
    },
    {
      thought:
        "All browsers (except Safari) now legally allow `<link rel='stylesheet'>` outside of the <head> tags, effectively achieving a progressive render.",
      citation: "Harry Roberts",
      tags: ["performance", "CSS"],
    },
    {
      thought:
        "With HTTP/2, multiple smaller stylesheets in the `<head>` give a faster fcp (first contentful paint) than a single all-encompassing stylesheet",
      citation: "Harry Roberts",
      tags: ["performance", "CSS"],
    },
    {
      thought:
        "Multiple stylesheets make better use of the browser cache: a change to one file will leave the others unchanged in the cache.",
      citation: "Harry Roberts",
      tags: ["performance", "CSS"],
    },
    {
      thought:
        "## `content-visibility: [visible | hidden | auto]` \n Omitting large swathes of rendering work gives a faster fcp (first contentful paint); use content-visibility to render modals, tooltips, menu overlays, footers, etc, only when they're seen.",
      citation: "",
      tags: ["performance", "CSS"],
    },
    {
      thought:
        "## `line-clamp: [visible | hidden | auto]` \n Limits the contents of a block container to the specified number of lines; draft but great support; requires `-webkit` prefix and only works in combination with the `display` property set to `-webkit-box` or `-webkit-inline-box` and the `-webkit-box-orient` property set to `vertical`.",
      citation: "",
      tags: ["performance", "CSS"],
    },
    {
      thought:
        "## Don't use CSS imports ... ever! \n They simply add unnecessary extra network calls. When using HTTP/2, `<link>` tags are faster.",
      citation: "",
      tags: ["performance", "CSS"],
    },
    {
      thought:
        "## Don't use monolithic, 3rd-party CSS libraries. \n Much of their CSS goes unused and big files slow your start render. They also tend to encourage more CSS to undo their effects. Always aim to reduce your CSS footprint.",
      citation: "",
      tags: ["performance", "CSS"],
    },
    {
      thought:
        "## Self-host 3rd party CSS and JS. \n Don't link out to a third party domain for your static assets; negotiating a new domain brings additional delays. It also lets you control your own caching headers.",
      citation: "",
      tags: ["performance", "CSS", "JS", "hosting"],
    },
    {
      thought:
        "## Embedded CSS removes network delays \n Use a server-side include inside a `<style>` tag. Embed sectional CSS at the point where it's needed e.g. footer CSS just above the footer HTML. Keep the CSS in the <head> as small as possible. (Caching may be better for large CSS files)",
      citation: "",
      tags: ["performance", "CSS"],
    },
    {
      thought:
        "## `contain: none | strict | content | size | layout | style | paint` \n This allows the browser to recalculate layout, style, paint, size, or any combination of them for a limited area of the DOM and not the entire page, leading to obvious performance benefits. For example, when repainting on hover. Use Chrome's paint flashing rectangles to see its effect.  \n\n [read more about contain](https://developer.mozilla.org/en-US/docs/Web/CSS/contain)",
      citation: "",
      tags: ["performance", "CSS"],
    },
    {
      thought:
        `## Service Worker can pre-cache key pages.

Use different caches for different assets types so you don't have to cache-bust everything when one file changes.

Note, all updates to items in the cache must be explicitly requested; items will not expire so must be explicitly deleted.`,
      citation: "",
      tags: ["performance", "enhancements"],
    },
    {
      thought:
        `## object-fit: fill | contain | cover | none | scale-down

Sets how the content of a replaced element (image or video) should be resized to fit its container.`,
      citation: "",
      tags: ["css"],
    },
    {
      thought: `## object-position: 50% 50% | right top | left bottom  etc.

Specifies the alignment of the selected replaced element's contents within the element's box. Areas of the box which aren't covered by the replaced element's object will show the element's background.`,
      citation: "",
      tags: ["CSS"],
    },
    {
      thought: `## React: \`getDerivedStateFromProps\` and \`getSnapshotBeforeUpdate\`

The new static \`getDerivedStateFromProps\` lifecycle is invoked after a component is instantiated as well as before it is re-rendered. It can return an object to update \`state\`, or \`null\` to indicate that the new \`props\` do not require any \`state\` updates.

Together with \`componentDidUpdate\`, this new lifecycle should cover all use cases for the legacy \`componentWillReceiveProps\`.

**\`getDerivedStateFromProps\` adds significant complexity to components. This often leads to bugs. Consider simpler alternatives to derived state to make components predictable and maintainable.**

---

The new \`getSnapshotBeforeUpdate\` lifecycle is called right before mutations are made (e.g. before the DOM is updated). The return value for this lifecycle will be passed as the third parameter to \`componentDidUpdate\`. (This lifecycle isn’t often needed, but can be useful in cases like manually preserving scroll position during rerenders.)`,
      citation: "",
      tags: ["React, JS"],
    },
    {
      thought: `## \`Element.scrollIntoView()\`
      
Scrolls the element's parent container such that the element on which scrollIntoView() is called is visible to the user.  
Note: The element may scroll completely to the top or bottom depending on the layout of other elements.

    element.scrollIntoView();
    element.scrollIntoView(alignToTop); // Boolean parameter
    element.scrollIntoView(scrollIntoViewOptions); // Object parameter`,
      citation: "",
      tags: ["React, JS"],
    }
  ],
  ted: [
    {
      thought: "Takin’ on a challenge is a lot like riding a horse. If you’re comfortable while you’re doin’ it, you’re probably doin’ it wrong."
    },
    {
      thought: "Hey, hey, hey! If we see each other in our dreams. Let’s goof around a little bit, pretend like we don’t know each other."
    },
    {
      thought: "Fellas, I could watch you do this jaunty North Korean military thing you do all day, but I need a favor."
    },
    {
      thought: "When it comes to locker rooms, I like ’em just like my mother’s bathing suits. I only wanna see ’em in one piece."
    },
    {
      thought: "Walton: How do you take your tea?\nTed: Well, normally right back to the counter because there’s been a terrible mistake."
    },
    {
      thought: "Walton: Do you believe in ghosts?\nTed: I do, but more importantly, I believe they need to believe in themselves."
    },
    {
      thought: "I always thought that tea was just gonna taste like hot brown water. And you know what? I was right. It’s horrible. No, thank you."
    },
    { thought: "Even Woody and Buzz got under each other’s plastic." },
    {
      thought: "You beating yourself up is like Woody Allen playing the clarinet. I don’t want to hear it."
    },
    { thought: "Don’t let the wisdom of age be wasted on you." },
    {
      thought: "I know change can be scary. One minute, you are playing freeze tag out there at recess with all your buddies. Next thing you know, you’re getting zits, your voice gets low. And every time your art teacher, Ms. Scanlon, leans over your desk to check and see how your project’s going, you feel all squiggly inside."
    },
    { thought: "I think that’s what it’s all about. Embracing change." },
    {
      thought: "One more person says something to me and Beard don’t understand. I’m gonna have one of my son’s classic temper tantrums. It’s basically just him calling me a bunch of silly names, you know, like, I don’t know, ‘dummy head’ or ‘poo-poo face’ ‘pee-pee fingers.'"
    },
    { thought: "Tea and I are still on a lifelong hiatus." },
    {
      thought: "I promise you, there is something worse out there than being sad. And that is being alone and being sad. Ain’t no one in this room alone."
    },
    {
      thought: "All right, fellas, you gotta remember, your body is like day-old rice. If it ain’t warmed up properly, something real bad could happen."
    },
    {
      thought: "If God would have wanted games to end in a tie, she wouldn’t have invented numbers."
    },
    {
      thought: "You gonna give me the cold shoulder and the silent treatment. That’s a combo. Does it come with a medium drink?"
    },
    { thought: "I believe in hope. I believe in Believe." },
    { thought: "Smells like potential." },
    {
      thought: "Seems like a smurf with an attitude would be a lot of fun to watch."
    },
    {
      thought: "Sounds to me like someone’s trapped inside life’s most complicated shape. A love triangle. Second place of course is the ‘I just walked in on my mother-in-law changing into her swimsuit dodecahedron.'"
    },
    { thought: "You tore your butt. That’s nothing to be ashamed of." },
    { thought: "Knock-a-doodle-doo!" },
    { thought: "Early drinkin’ means quick drunken." },
    {
      thought: "I think if you care about someone and you got a little love in your heart, there ain’t nothin you can’t get through together."
    },
    {
      thought: "Roy, I learned two pretty big lessons on the rough and tumble playgrounds of Bookridge Elementary School. One, if little Ronnie Fouch offers you a candy bar, you immediately say no and get the hell out of there cause there’s a good chance that little son of a gun has pooped inside of a Butterfinger wrapper. No one ever saw him do it, but a couple people ate it. Number two, teacher tells a bully not to pick on someone, it’s just gonna make it worse."
    },
    {
      thought: "I think I literally have a better understanding of who killed Kennedy than what is offside. (Long pause) It was the mob."
    },
    {
      thought: "If you would have told me that I’d be drinking tea at three o’clock every day… about a year ago… I would have punched you in the mouth."
    },
    {
      thought: "In my mind, you gotta have three things to be a Premier League team. 1) You gotta play physical. 2) you gotta give 100 percent until the final whistle and 3) you gotta be sponsored by a Middle-Eastern airline."
    },
    { thought: "How many countries are in this country?" },
    { thought: "Be curious. Not judgmental." },
    {
      thought: "You know what the happiest animal on Earth is? It’s a goldfish. You know why? Got a ten-second memory. Be a goldfish, Sam."
    },
    {
      thought: "Jamie Tartt: Coach, I’m me. Why would I want to be anything else?\nTed: I’m not sure you realize how psychologically healthy that actually is."
    },
    {
      thought: "Hey, takin’ on a challenge is a lot like ridin’ a horse. If you’re comfortable while you’re doin’ it, you’re probably doin’ it wrong."
    },
    {
      thought: "This woman right here is strong, confident, and powerful. Boss, I tell ya, I’d hate to see you and Michelle Obama arm wrestle, but I wouldn’t be able to take my eyes off it, either."
    },
    {
      thought: "Coach Beard: Why you windin’ him up?\nTed: Because he’s the one, coach. If we’re gonna make an impact here, the first domino needs to fall right inside of that man’s heart."
    },
    {
      thought: "For me, success is not about the wins and losses. It’s about helping these young fellas be the best versions of themselves on and off the field."
    },
    {
      thought: "I like the idea of someone becoming rich because of what they gave to the world, not just because of who their family is."
    },
    {
      thought: "Little girls are mysterious. And silly and powerful. I gave up trying to figure them out years ago."
    },
    {
      thought: "I want you to know, I value each of your opinions, even when you’re wrong."
    },
    { thought: "Our goal is to go out like Willie Nelson — on a high!" },
    {
      thought: "When it comes to locker rooms, I like ’em just like my mother’s bathing suits. I only wanna see ’em in one piece."
    },
    { thought: "I’m looking forward to the definition of relegation." },
    { thought: "Ties and no playoffs? Why do you even do this?" },
    {
      thought: "Come on Rob! You gotta get it in there to get three points!"
    },
    {
      thought: "Will you explain to me how that was offside? No! I’m asking you. Seriously! Explain offside to me. It makes no sense."
    }
  ],
  colours: ["palevioletred",
    "darkslategray",
    "steelblue",
    "darkslateblue",
    "darkcyan",
    "darkolivegreen",
    "indianred",
    "#0084A1",
    "#5D81BB",
    "#7AAB55",
    "#5DAFAC",
    "#A9568C",
    "#8A9992",
    "#669287",
    "#99c5c4",
    "#895c79",
    "#EBA851",
    "#535040",
  ]
};
data.toShow = data[data.show];

// randomly shuffles an array
const fisherYatesShuffle = (array) => {
  var count = array.length,
    randomNumber,
    temp;
  while (count) {
    randomNumber = (Math.random() * count--) | 0;
    temp = array[count];
    array[count] = array[randomNumber];
    array[randomNumber] = temp;
  }
};
fisherYatesShuffle(data.toShow);

let thoughtNumber = 0;

const Quote = (props) => {
  return (
    <div className="quote">
      <blockquote className="quote-block">
        <ReactMarkdown>{props.thought}</ReactMarkdown>
      </blockquote>
      <cite className="quote-cite">{props.cite}</cite>
    </div>
  );
};

const Tech = (props) => {
  return (
    <div className="tech">
      <blockquote className="tech-block">
        <ReactMarkdown>{props.thought}</ReactMarkdown>
      </blockquote>
      <cite className="tech-cite">{props.cite}</cite>
    </div>
  )
}

function App() {
  const [quote, setQuote] = useState(data.toShow[thoughtNumber]);
  const [quoteId, setQuoteId] = useState(thoughtNumber);
  useEffect(() => {
    const interval = setInterval(() => {
      thoughtNumber = (thoughtNumber + 1) % data.toShow.length;
      setQuote(data.toShow[thoughtNumber]);
      setQuoteId(thoughtNumber);
    }, 20000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="App"
      style={{ background: data.colours[Math.floor(Math.random() * data.colours.length)], color: "white" }}
    >
      <header className="App-header">
        {data.show === "tech" ? (
          <Tech
            thought={quote.thought}
            cite={quote.citation}
            key={quoteId}
          ></Tech>
        ) : (
          <Quote
            thought={quote.thought}
            cite={quote.citation}
            key={quoteId}
          ></Quote>
        )}
      </header>
    </div>
  );
}

export default App;
